/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 14);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (new Vue());

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(22),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(21),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(18),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(20),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        value: {
            type: String,
            required: true
        },
        def: {
            type: String,
            default: ''
        },
        name: String,
        theme: String
    },
    data: function () {
        return {
            editor: null,
            contentBackup: ""
        };
    },
    watch: {
        value: function (val) {
            if (this.contentBackup !== val) this.editor.setValue(val, 1);
        }
    },
    mounted: function () {
        var self = this;

        var editor = self.editor = ace.edit(this.$el);
        editor.setShowPrintMargin(false);
        editor.setTheme("ace/theme/tomorrow_night");
        editor.getSession().setMode("ace/mode/twig");
        editor.renderer.setScrollMargin(5, 5, 0, 0);

        this.$emit('init', editor);
        this.$emit('input', this.def);

        editor.$blockScrolling = Infinity;
        editor.setValue(this.value, 1);

        editor.on('change', function () {
            var content = editor.getValue();
            self.$emit('input', content);
            self.$emit('change', content);
            self.contentBackup = content;
        });
    }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Bus_js__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		componentId: String,
		metaType: String,
		titlePlaceholder: String,
		descPlaceholder: String,
		namePlaceholder: String,
		valuePlaceholder: String,
		buttonTitle: String,
		def: {
			type: Array,
			default: function () {
				return [];
			}
		},
		radios: {
			type: Array,
			default: function () {
				return [];
			}
		},
		tooltips: {
			type: Array,
			default: function () {
				return [];
			}
		},
		radioDesc: String,
		checkboxDesc: String,
		checkboxTooltip: String,
		rows: Array,
		needValue: {
			type: Boolean,
			default: false
		},
		hasInputs: {
			type: Boolean,
			default: true
		},
		hasControls: {
			type: Boolean,
			default: true
		},
		hasExtendedControls: {
			type: Boolean,
			default: false
		},
		hasRadios: {
			type: Boolean,
			default: false
		},
		hasCheckbox: {
			type: Boolean,
			default: false
		},
		booleans: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			showIndex: [],
			editMode: false,
			init: true,
			addTitle: sm.addTitle,
			editTitle: sm.editTitle,
			deleteTitle: sm.deleteTitle,
			collapseTitle: sm.collapseTitle,
			emptyTitle: sm.emptyTitle,
			titleInput: '',
			descInput: '',
			nameInput: '',
			valueInput: '',
			radioInput: '0',
			currentIndex: null,
			checkboxInput: '',
			errorMsg: '',
			errorShow: false
		};
	},
	mounted: function () {
		jQuery(document).ready(function ($) {
			$('.sm-info').tooltip({
				placement: $(this).attr('data-placement'),
				html: true,
				viewport: { selector: 'body', padding: 0 },
				template: '<div class="sm-tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
			});
		});
		this.$emit('rows', this.def);
		var self = this;
		__WEBPACK_IMPORTED_MODULE_0__Bus_js__["a" /* default */].$on('focus', function (id) {
			if (self.componentId == id) {
				self.$refs.inputName.focus();
			}
		});
		__WEBPACK_IMPORTED_MODULE_0__Bus_js__["a" /* default */].$on('checkMethod', function (id, method) {
			if (self.componentId == id) {
				for (var i = 0, len = self.rows.length; i < len; i++) {
					if (self.rows[i].name == method) {
						self.$emit('edit', self.rows[i]);
					}
				}
			}
		});
		__WEBPACK_IMPORTED_MODULE_0__Bus_js__["a" /* default */].$on('fullDic', function (id, rows) {
			if (self.componentId == id) {
				self.showIndex.splice(0, self.showIndex.length);
				for (var i = 0; i < rows.length; i++) {
					for (var g = 0; g < self.rows.length; g++) {
						if (self.rows[g].name == rows[i].name) {
							self.deleteRow(g, true);
						}
					}
					if (rows[i].value.length > 0) {
						self.rows.push({
							title: rows[i].title,
							desc: rows[i].desc,
							name: rows[i].name.toLowerCase(),
							value: rows[i].value,
							radio: rows[i].radio,
							checkbox: rows[i].checkbox
						});
					}
				}
				self.init = false;
				for (var i = 0; i < self.rows.length; i++) {
					if (i != self.rows.length - 1) {
						var val;
						try {
							val = JSON.parse(self.rows[i].value);
							if (typeof val == 'object') {
								self.showIndex.push(i);
							}
						} catch (e) {}
					}
				}
				self.titleInput = self.descInput = self.valueInput = self.valueInput = '';
				self.radioInput = '0';
				self.checkboxInput = '';
				self.currentIndex = null;
				self.$emit('changed', self.rows);
			}
		});
	},
	methods: {
		rowsId: function () {
			return this.metaType + 's';
		},
		inputValues: function () {
			return JSON.stringify(this.rows);
		},
		addRow: function () {
			if (this.validate()) {
				if (!this.editMode) {
					this.rows.push({
						title: this.titleInput,
						desc: this.descInput,
						name: this.nameInput.toLowerCase(),
						value: this.valueInput,
						radio: this.radioInput,
						checkbox: this.checkboxInput
					});
				} else {
					this.rows[this.currentIndex].title = this.titleInput;
					this.rows[this.currentIndex].desc = this.descInput;
					this.rows[this.currentIndex].name = this.nameInput.toLowerCase();
					this.rows[this.currentIndex].value = this.valueInput;
					this.rows[this.currentIndex].radio = this.radioInput;
					this.rows[this.currentIndex].checkbox = this.checkboxInput;
					this.editMode = false;
				}
				this.titleInput = this.descInput = this.nameInput = this.valueInput = '';
				this.radioInput = '0';
				this.checkboxInput = '';
				this.currentIndex = null;
				this.$refs.inputName.focus();
				this.$emit('changed', this.rows);
			}
		},
		deleteRow: function (index, notClickEvent) {
			this.init = true;
			if (!notClickEvent) {
				this.$emit('delete', this.rows[index]);
			}
			this.rows.splice(index, 1);
			if (this.hasControls) {
				this.titleInput = this.descInput = this.nameInput = this.valueInput = '';
				this.radioInput = '0';
				this.checkboxInput = '';
				this.$refs.inputName.focus();
			}
			this.currentIndex = null;
			this.editMode = false;
			this.$emit('changed', this.rows);
		},
		editRow: function (index) {
			this.currentIndex = index;
			this.editMode = true;
			if (this.hasControls) {
				this.titleInput = this.rows[index].title;
				this.descInput = this.rows[index].desc;
				this.nameInput = this.rows[index].name;
				this.valueInput = this.rows[index].value;
				this.radioInput = this.rows[index].radio;
				this.checkboxInput = this.rows[index].checkbox;
				this.$refs.inputName.focus();
			}
			this.$emit('edit', this.rows[index]);
		},
		collapseRow: function (index) {
			this.init = false;
			this.showIndex.splice(this.showIndex.indexOf(index), 1);
		},
		calculateValue: function (value, index) {
			var self = this;
			var val;
			try {
				val = JSON.parse(value);
				var temp = '';
				var count = 0;
				if (typeof val == 'object') {
					for (var item in val) {
						if (val.hasOwnProperty(item)) {
							temp += '<div class="sm-arg-block first-level"><div><span class="sm-array-key">' + item + '</span>' + '<span class="sm-query-sep sm-query-sep-arrow sm-query-sep-key"></span></div><div>' + self.recurringValue(val[item]) + '</div></div>';
						}
						count++;
					}
					val = temp;
					if (self.init) self.showIndex.push(index);
					return val;
				}
			} catch (e) {}
			if (value.length != 0) {
				val = '<span class="value params">' + value + '</span>';
			} else {
				val = '<span class="empty-value">' + this.emptyTitle + '</span>';
			}
			return val;
		},
		showFull: function (index) {
			if (this.showIndex.indexOf(index) != -1) return false;
			return true;
		},
		recurringValue: function (value) {
			var self = this;
			var val = '<span class="value">' + value + '</span>';
			if (typeof value == 'object') {
				var temp = '';
				var count = 0;
				for (var item in value) {
					if (value.hasOwnProperty(item)) {
						temp += '<div class="sm-arg-block sm-arg-array';
						if (count == 0) temp += ' first';
						if (count == Object.keys(value).length - 1) temp += ' last';
						temp += '"><div><span class="sm-query-sep sm-query-sep-arrow sm-query-sep-key"></span><span class="sm-array-key">' + item + '</span>' + '<span class="sm-query-sep sm-query-sep-arrow sm-query-sep-key"></span></div><div>' + self.recurringValue(value[item]) + '</div></div>';
					}
					count++;
				}
				val = temp;
			}
			return val;
		},
		error: function (type) {
			this.errorShow = false;
			this.$refs.inputName.focus();
			switch (type) {
				case 'badInput':
					this.errorMsg = sm.errorBadInput;
					break;
				case 'duplicates':
					this.errorMsg = sm.errorDuplicates;
					break;
				default:
					this.errorMsg = sm.errorDefault;
					break;
			}
			this.errorShow = true;
		},
		validate: function () {
			var valid = true;
			var title = this.titleInput;
			var desc = this.descInput;
			var name = this.nameInput;
			var value = this.valueInput;
			var error = this.error;
			var reg = /^([a-zA-Z0-9-_]*|{\[[a-zA-Z0-9_| '"(),]*\]})$/;
			var reg2 = /^([a-zA-Z0-9-_ ]*|{\[[a-zA-Z0-9_| '"(),]*\]})$/;
			if (name !== "") {
				if (value === "" && this.needValue) {
					error('badInput');
					return false;
				}
				if (!reg.test(name)) {
					error('badInput');
					valid = false;
				}
				if (!reg2.test(title)) {
					error('badInput');
					valid = false;
				}
				if (!reg2.test(desc)) {
					error('badInput');
					valid = false;
				}
				if (!this.editMode) {
					this.rows.filter(function (row) {
						if (row.name == name) {
							error('duplicates');
							valid = false;
						}
					});
				}
				if (this.booleans) {
					if ((value === "" || value === 'false') && this.radioInput == '1') {
						this.valueInput = 'false';
					} else if (value !== "" && this.radioInput == '1') this.valueInput = 'true';
				}
			} else {
				valid = false;
			}
			return valid;
		}
	}
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['group', 'icon'],
	methods: {
		listGroups: function () {
			this.$emit('groups', this.group);
		}
	}
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['method', 'content', 'className'],
	class: '',
	template: '<button @click="addMethod" type="button" class="sm-button sm-edit-button" :class="className"><slot></slot></button>',
	methods: {
		addMethod: function () {
			if (!this.content) {
				var method = '{[ ' + this.method + ' ]}';
				if (/[\-]/.test(this.method)) {
					var method = '{[ attribute(atts, \'' + this.method + '\') ]}';
				}
			} else {
				var method = '{@ ' + this.method + ' @}';
			}
			this.$emit('method', method);
		}
	}
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Bus_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TreeInput_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TreeInput_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__TreeInput_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GroupButton_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GroupButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__GroupButton_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		smTreeInput: __WEBPACK_IMPORTED_MODULE_1__TreeInput_vue___default.a,
		smGroupButton: __WEBPACK_IMPORTED_MODULE_2__GroupButton_vue___default.a
	},
	props: {
		componentId: String,
		valuePlaceholder: String,
		buttonTitle: String,
		backTitle: String,
		qb: {
			type: Array,
			default: function () {
				return [];
			}
		},
		params: Array
	},
	data: function () {
		return {
			values: [],
			valueInput: '',
			currentID: '',
			currentGroup: '',
			currentMethod: '',
			currentName: '',
			currentType: '',
			currentDesc: '',
			editTitle: sm.editTitle,
			deleteTitle: sm.deleteTitle,
			addTitle: sm.addTitle,
			editMode: false,
			firstActive: true,
			secondActive: false,
			thirdActive: false,
			defaultInput: true,
			isActiveStep1: 'active',
			isActiveStep2: '',
			isActiveStep3: '',
			errorMsg: '',
			errorShow: false,
			defQuery: {},
			strings: {
				'queryMainDesc': sm.queryMainDesc,
				'step1': sm.step1,
				'step2': sm.step2,
				'step3': sm.step3,
				'queryGroup': sm.queryGroup,
				'queryMethod': sm.queryMethod,
				'queryArgs': sm.queryArgs,
				'queryDesc': sm.queryDesc,
				'queryDescCP': sm.queryDescCP
			}
		};
	},
	mounted: function () {
		var self = this;
		__WEBPACK_IMPORTED_MODULE_0__Bus_js__["a" /* default */].$on('editCurrentArg', function (id, row) {
			if (self.componentId == id) {
				self.currentType = null;
				self.currentDesc = '';
				self.defaultInput = true;
				self.isActiveStep1 = 'active';
				self.isActiveStep2 = 'active';
				self.isActiveStep3 = 'active';
				self.firstActive = false;
				self.secondActive = false;
				self.thirdActive = true;
				for (var i = 0; i < self.qb.length; i++) {
					for (var g = 0; g < self.qb[i].methods.length; g++) {
						if (self.qb[i].methods[g].method == row.name) {
							self.currentGroup = i;
							self.currentMethod = row.name;
							self.currentID = self.qb[i].id;
							self.currentName = self.qb[i].methods[g].name;
							self.currentType = self.qb[i].methods[g].type;
							if (self.currentType == 'taxonomy' || self.currentType == 'meta' || self.currentType == 'date') self.defaultInput = false;
							if (self.currentType == 'year' || self.currentType == 'month' || self.currentType == 'day' || self.currentType == 'week' || self.currentType == 'hour' || self.currentType == 'minute' || self.currentType == 'second' || this.currentType == 'yearmonth') {
								var desc = self.currentType + 'Desc';
								self.currentDesc = sm[desc];
							}
							self.parseValue(row.value, self.qb[i].methods[g].type);
						}
					}
				}
			}
		});
		__WEBPACK_IMPORTED_MODULE_0__Bus_js__["a" /* default */].$on('deleteCurrentArg', function (id, row) {
			if (self.componentId == id) {
				if (self.thirdActive && self.currentMethod == row.name) {
					self.values = [];
					self.defQuery = {};
					__WEBPACK_IMPORTED_MODULE_0__Bus_js__["a" /* default */].$emit('updateValues', 'query-tree', self.defQuery);
				}
			}
		});
	},
	computed: {
		treeData: function () {
			var obj = {};
			switch (this.currentType) {
				case 'taxonomy':
					obj.buttonTitle = sm.buttonTax;
					obj.defs = {
						'taxonomy': {
							'type': 'string',
							'title': sm.taxTitle,
							'placeholder': sm.taxPlaceholder,
							'desc': sm.taxDesc,
							'req': true,
							'input': true
						},
						'field': {
							'type': 'param',
							'title': sm.fieldTitle,
							'values': ['term_id', 'name', 'slug', 'term_taxonomy_id']
						},
						'terms': {
							'type': 'array',
							'title': sm.termsTitle,
							'placeholder': sm.termsPlaceholder,
							'desc': sm.termsDesc,
							'req': true,
							'input': true
						},
						'operator': {
							'type': 'param',
							'title': sm.operatorTitle,
							'values': ['IN', 'NOT IN', 'AND', 'EXISTS', 'NOT EXISTS']
						},
						'include_children': {
							'type': 'param',
							'title': sm.includeTitle,
							'values': ['TRUE', 'FALSE']
						}
					};
					obj.queryName = 'tax_query';
					break;
				case 'meta':
					obj.buttonTitle = sm.buttonMeta;
					obj.defs = {
						'key': {
							'type': 'string',
							'title': sm.keyTitle,
							'placeholder': sm.metaPlaceholder,
							'desc': sm.metaKeyDesc,
							'req': true,
							'input': true
						},
						'value': {
							'type': 'array',
							'title': sm.valueTitle,
							'placeholder': sm.metaValuesPlaceholder,
							'desc': sm.metaValueDesc,
							'input': true
						},
						'compare': {
							'type': 'param',
							'title': sm.compareTitle,
							'values': ['=', '!=', '>', '>=', '<', '<=', 'LIKE', 'NOT LIKE', 'IN', 'NOT IN', 'BETWEEN', 'NOT BETWEEN', 'EXISTS', 'NOT EXISTS', 'REGEXP', 'NOT REGEXP', 'RLIKE']
						},
						'type': {
							'type': 'param',
							'title': sm.typeTitle,
							'values': ['CHAR', 'NUMERIC', 'BINARY', 'DATE', 'DATETIME', 'DECIMAL', 'SIGNED', 'TIME', 'UNSIGNED']
						}
					};
					obj.queryName = 'meta_query';
					break;
				case 'date':
					obj.buttonTitle = sm.buttonDate;
					obj.defs = {
						'year': {
							'type': 'intarray',
							'title': sm.yearTitle,
							'placeholder': sm.yearPlaceholder,
							'desc': sm.yearDesc,
							'reg': /^((19|20)\d{2}|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'month': {
							'type': 'intarray',
							'title': sm.monthTitle,
							'placeholder': sm.monthPlaceholder,
							'desc': sm.monthDesc,
							'reg': /^(1[0-2]|[1-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'week': {
							'type': 'intarray',
							'title': sm.weekTitle,
							'placeholder': sm.weekPlaceholder,
							'desc': sm.weekDesc,
							'reg': /^(5[0-3]|[1-4][0-9]|[0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'day': {
							'type': 'intarray',
							'title': sm.dayTitle,
							'placeholder': sm.dayPlaceholder,
							'desc': sm.dayDesc,
							'reg': /^([1-9]|[1-2][0-9]|3[0-1]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'dayofyear': {
							'type': 'intarray',
							'title': sm.dayOfYearTitle,
							'placeholder': sm.dayOfYearPlaceholder,
							'desc': sm.dayOfYearDesc,
							'reg': /^([1-9]|[1-9][0-9]|[1-2][0-9][0-9]|3[0-6][0-6]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'dayofweek': {
							'type': 'intarray',
							'title': sm.dayOfWeekTitle,
							'placeholder': sm.dayOfWeekPlaceholder,
							'desc': sm.dayOfWeekDesc,
							'reg': /^([1-7]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'dayofweek_iso': {
							'type': 'intarray',
							'title': sm.dayOfWeekIsoTitle,
							'placeholder': sm.dayOfWeekIsoPlaceholder,
							'desc': sm.dayOfWeekIsoDesc,
							'reg': /^([1-7]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'hour': {
							'type': 'intarray',
							'title': sm.hourTitle,
							'placeholder': sm.hourPlaceholder,
							'desc': sm.hourDesc,
							'reg': /^(2[0-3]|1[0-9]|[0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'minute': {
							'type': 'intarray',
							'title': sm.minuteTitle,
							'placeholder': sm.minutePlaceholder,
							'desc': sm.minuteDesc,
							'reg': /^(5[0-9]|[0-9]|[1-4][0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'second': {
							'type': 'intarray',
							'title': sm.secondTitle,
							'placeholder': sm.secondPlaceholder,
							'desc': sm.secondDesc,
							'reg': /^(5[0-9]|[0-9]|[1-4][0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/,
							'input': true
						},
						'after': {
							'type': 'date',
							'title': sm.afterDateTitle,
							'placeholder': sm.afterDatePlaceholder,
							'desc': sm.afterDateDesc,
							'input': true
						},
						'before': {
							'type': 'date',
							'title': sm.beforeDateTitle,
							'placeholder': sm.beforeDatePlaceholder,
							'desc': sm.beforeDateDesc,
							'input': true
						},
						'column': {
							'type': 'param',
							'title': sm.columnDateTitle,
							'values': ['post_date', 'post_date_gmt', 'post_modified', 'post_modified_gmt', 'comment_date', 'comment_date_gmt', 'user_registered', 'registered', 'last_updated']
						},
						'compare': {
							'type': 'param',
							'title': sm.compareTitle,
							'values': ['=', '!=', '>', '>=', '<', '<=', 'IN', 'NOT IN', 'BETWEEN', 'NOT BETWEEN']
						},
						'inclusive': {
							'type': 'param',
							'title': sm.inclusiveTitle,
							'values': ['FALSE', 'TRUE']
						}
					};
					obj.queryName = 'date_query';
					break;
			}
			return obj;
		},
		currentFlat: function () {
			var str = '';
			var self = this;
			switch (this.currentType) {
				case "year":
				case "month":
				case "week":
				case "day":
				case "hour":
				case "minute":
				case "second":
				case "yearmonth":
				case 'string':
					for (var i = 0; i < this.values.length; i++) {
						str += this.values[i];
						if (i != self.values.length - 1) str += ',';
					}
					break;
				case 'array':
					if (this.values.length > 0) str += '{';
					for (var i = 0; i < this.values.length; i++) {
						str += '"' + i + '":"' + this.values[i] + '"';
						if (i != self.values.length - 1) str += ',';
					}
					if (this.values.length > 0) str += '}';
					break;
			}
			return str;
		}
	},
	methods: {
		backStep: function () {
			if (this.secondActive) {
				this.secondActive = false;
				this.firstActive = true;
				this.isActiveStep2 = '';
				this.currentGroup = '';
				this.currentID = '';
			}
			if (this.thirdActive) {
				this.values = [];
				this.valueInput = '';
				this.thirdActive = false;
				this.defaultInput = true;
				this.secondActive = true;
				this.isActiveStep3 = '';
				this.currentMethod = '';
				this.currentType = '';
				this.currentName = '';
				this.currentDesc = '';
				this.errorShow = false;
			}
		},
		stepMethods: function (group, id) {
			this.currentID = id;
			this.currentGroup = group;
			this.firstActive = false;
			this.secondActive = true;
			this.isActiveStep2 = 'active';
		},
		stepArgs: function (name, method, type) {
			this.currentName = name;
			this.currentMethod = method;
			this.currentType = type;
			this.secondActive = false;
			this.thirdActive = true;
			this.isActiveStep3 = 'active';
			if (this.currentType == 'taxonomy' || this.currentType == 'meta' || this.currentType == 'date') this.defaultInput = false;
			if (this.currentType == 'year' || this.currentType == 'month' || this.currentType == 'day' || this.currentType == 'week' || this.currentType == 'hour' || this.currentType == 'minute' || this.currentType == 'second' || this.currentType == 'yearmonth') {
				var desc = this.currentType + 'Desc';
				this.currentDesc = sm[desc];
			}
			this.defQuery = {};
			this.$emit('check', method);
		},
		emitChanges: function (flat, method) {
			var value = {};
			if (flat && this.currentType == 'taxonomy' || flat && this.currentType == 'meta' || flat && this.currentType == 'date') {
				value = JSON.parse(flat);
				this.defQuery = value;
			}
			this.$emit('changed', flat, method);
		},
		addValue: function () {
			var self = this;
			if (this.validate()) {
				if (!this.editMode) {
					this.values.push(this.valueInput);
				} else {
					Vue.set(this.values, this.currentIndex, this.valueInput);
					this.editMode = false;
				}
				this.valueInput = '';
				this.$refs.inputValueArg.focus();
				self.emitChanges(self.currentFlat, self.currentMethod);
			}
		},
		deleteRow: function (index) {
			this.values.splice(index, 1);
			this.emitChanges(this.currentFlat, this.currentMethod);
		},
		editRow: function (index) {
			this.currentIndex = index;
			this.editMode = true;
			this.valueInput = this.values[index];
			this.$refs.inputValueArg.focus();
		},
		parseValue: function (value, type) {
			var self = this;
			this.values = [];
			switch (type) {
				case "year":
				case "month":
				case "week":
				case "day":
				case "hour":
				case "minute":
				case "second":
				case "yearmonth":
				case 'string':
					value = value.split(',');
					if (value) {
						for (var i = 0; i < value.length; i++) {
							self.values.push(value[i]);
						}
					}
					break;
				case 'array':
					value = JSON.parse(value);
					if (value) {
						for (var item in value) {
							if (value.hasOwnProperty(item)) {
								self.values.push(value[item]);
							}
						}
					}
					break;
				case 'taxonomy':
				case 'meta':
				case 'date':
					value = JSON.parse(value);
					self.defQuery = value;
					__WEBPACK_IMPORTED_MODULE_0__Bus_js__["a" /* default */].$emit('updateValues', 'query-tree', self.defQuery);
					break;
			}
		},
		error: function (type) {
			this.errorShow = false;
			this.$refs.inputValueArg.focus();
			switch (type) {
				case 'badInput':
					this.errorMsg = sm.errorBadInput;
					break;
				case 'duplicates':
					this.errorMsg = sm.errorDuplicatesValues;
					break;
				default:
					this.errorMsg = sm.errorDefault;
					break;
			}
			this.errorShow = true;
		},
		validate: function () {
			var valid = true;
			var value = this.valueInput;
			var error = this.error;
			if (value === "") {
				error('badInput');
				return false;
			}
			if (this.currentType == 'year' && !/^((19|20)\d{2}|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '') {
				error('badInput');
				return false;
			}
			if (this.currentType == 'month' && !/^(1[0-2]|[1-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '') {
				error('badInput');
				return false;
			}
			if (this.currentType == 'week' && !/^(5[0-3]|[1-4][0-9]|[0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '') {
				error('badInput');
				return false;
			}
			if (this.currentType == 'day' && !/^([1-9]|[1-2][0-9]|3[0-1]|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '') {
				error('badInput');
				return false;
			}
			if (this.currentType == 'hour' && !/^(2[0-3]|1[0-9]|[0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '') {
				error('badInput');
				return false;
			}
			if (this.currentType == 'minute' && !/^(5[0-9]|[0-9]|[1-4][0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '') {
				error('badInput');
				return false;
			}
			if (this.currentType == 'second' && !/^(5[0-9]|[0-9]|[1-4][0-9]|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '') {
				error('badInput');
				return false;
			}
			if (this.currentType == 'yearmonth' && !/^((19|20)\d{2}(1[0-2]|0[1-9])|{\[[a-zA-Z0-9_| '"(),]*\]})$/.test(value) && value != '') {
				error('badInput');
				return false;
			}
			if (!this.editMode) {
				this.values.filter(function (row) {
					if (row == value) {
						error('duplicates');
						valid = false;
					}
				});
			}
			return valid;
		}
	}
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	props: ['tag'],
	methods: {
		addTag: function () {
			this.$emit('tag', this.tag);
		}
	}
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Bus_js__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	props: {
		componentId: String,
		buttonTitle: String,
		eventQuery: String,
		defData: {
			type: Object,
			default: function () {
				return {};
			}
		},
		def: {
			type: Object,
			default: function () {
				return {};
			}
		}
	},
	data: function () {
		return {
			values: {},
			treeInputs: {},
			errorMsg: '',
			currentRelation: '',
			currentRow: null,
			errorShow: false,
			editMode: false,
			flat: '',
			list: [],
			checkedRows: [],
			relationTitle: sm.relationship,
			groupTitle: sm.groupTitle,
			addTitle: sm.addTitle,
			editTitle: sm.editTitle
		};
	},
	computed: {
		primaryKeys: function () {
			var arr = [];
			for (var obj in this.defData) {
				if (this.defData[obj].input) arr.push(obj);
			}
			return arr;
		},
		inputs: function () {
			var inps = {};
			for (var obj in this.defData) {
				if (this.defData[obj].input) inps[obj] = this.defData[obj].placeholder;
			}
			return inps;
		}
	},
	mounted: function () {
		var self = this;
		__WEBPACK_IMPORTED_MODULE_0__Bus_js__["a" /* default */].$on('updateValues', function (id, values) {
			if (self.componentId == id) {
				self.values = values;
				self.flat = self.currentFlatMethod(self.values);
				self.list = self.getFlatValues(self.values);
				self.errorShow = false;
			}
		});
		this.values = this.def;
		this.flat = this.currentFlatMethod(this.values);
		this.list = this.getFlatValues(this.values);
	},
	methods: {
		checkboxId: function (index) {
			return 'sm-cb' + index;
		},
		relationMargin: function (level) {
			var margin = 97;
			if (level > 0) margin = 125;
			return 'margin-left:' + margin + 'px';
		},
		liPadding: function (level) {
			return 'padding-left:' + 40 * level + 'px';
		},
		checkPadding: function (type) {
			var cl = null;
			if (type == 'array' || type == 'date' || type == 'intarray') cl = 'sm-pr10';
			return cl;
		},
		checkClass: function (type) {
			var cl = null;
			if (this.primaryKeys.indexOf(type) !== -1) cl = 'sm-array-key';
			return cl;
		},
		checkPrimaryKeys: function (obj1, obj2) {
			var checked = true;
			for (var i = 0; i < this.primaryKeys.length; i++) {
				var item = this.primaryKeys[i];
				if (obj1[item] != obj2[item]) checked = false;
			}
			return checked;
		},
		assignPrimaryKeys: function (obj1, obj2) {
			for (var i = 0; i < this.primaryKeys.length; i++) {
				var item = this.primaryKeys[i];
				obj1[item] = obj2[item];
			}
		},
		recurringSwitch: function (objs, obj, parent, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var recurring = false;
			for (var o in objs) {
				if (typeof objs[o] != 'string') {
					if (objs == parent && Object.keys(objs).length - 1 > Object.keys(obj).length) {
						var currentIndex;
						for (var ob in objs) {
							if (typeof objs[ob] != 'string') {
								for (var oo in obj) {
									if (this.checkPrimaryKeys(objs[ob], obj[oo])) {
										if (!currentIndex) currentIndex = ob;
										if (ob < currentIndex) currentIndex = ob;
										delete objs[ob];
										break;
									}
								}
							}
						}
						objs[currentIndex] = obj;
						break;
					} else {
						for (var sub in objs[o]) {
							if (sub == parseInt(sub)) {
								recurring = true;
								break;
							}
						}
						if (recurring) {
							this.recurringSwitch(objs[o], obj, parent, next_level);
							recurring = false;
						}
					}
				}
			}
		},
		recurringRowEdit: function (objs, obj, newObj, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var recurring = false;
			for (var o in objs) {
				if (typeof objs[o] != 'string') {
					if (this.checkPrimaryKeys(objs[o], obj) && level == obj.level) {
						this.assignPrimaryKeys(objs[o], newObj);
						break;
					} else {
						for (var sub in objs[o]) {
							if (sub == parseInt(sub)) {
								recurring = true;
								break;
							}
						}
						if (recurring) {
							this.recurringRowEdit(objs[o], obj, newObj, next_level);
							recurring = false;
						}
					}
				}
			}
		},
		recurringRowDelete: function (objs, obj, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var currentKey, subKey;
			var recurring = false;
			var result = null;
			for (var o in objs) {
				if (typeof objs[o] != 'string') {
					if (this.checkPrimaryKeys(objs[o], obj) && level == obj.level) {
						delete objs[o];
					} else {
						currentKey = o;
						for (var sub in objs[o]) {
							if (sub == parseInt(sub)) {
								recurring = true;
								break;
							}
						}
						if (recurring) {
							var responce = this.recurringRowDelete(objs[o], obj, next_level);
							if (responce) {
								subKey = o;
								result = responce;
							}
							recurring = false;
						}
					}
				}
			}
			if (result && subKey) {
				objs[subKey] = result;
			}
			if (Object.keys(objs).length < 3 && objs.hasOwnProperty('relation')) {
				return objs[currentKey];
			}
			return null;
		},
		recurringChangeRelation: function (objs, obj, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var recurring = false;
			for (var o in objs) {
				if (o == 'relation') {
					if (level == obj.level && obj.parent == objs) {
						if (objs[o] == 'AND') {
							objs[o] = 'OR';
						} else {
							objs[o] = 'AND';
						}
					}
				} else {
					for (var sub in objs[o]) {
						if (sub == parseInt(sub)) {
							recurring = true;
							break;
						}
					}
					if (recurring) {
						this.recurringChangeRelation(objs[o], obj, next_level);
						recurring = false;
					}
				}
			}
		},
		recurringChangeParameter: function (objs, obj, key, values, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var recurring = false;
			for (var o in objs) {
				if (typeof objs[o] != 'string') {
					if (this.checkPrimaryKeys(objs[o], obj) && level == obj.level) {
						if (!objs[o][key]) {
							objs[o][key] = values[0];
						} else {
							var newOp;
							for (var index = 0; index < values.length; index++) {
								var op = values[index];
								if (objs[o][key] == op) {
									if (index < values.length - 1) {
										newOp = values[index + 1];
									} else {
										newOp = values[0];
									}
								}
							}
							if (!newOp) newOp = values[0];
							objs[o][key] = newOp;
						}
						break;
					} else {
						for (var sub in objs[o]) {
							if (sub == parseInt(sub)) {
								recurring = true;
								break;
							}
						}
						if (recurring) {
							this.recurringChangeParameter(objs[o], obj, key, values, next_level);
							recurring = false;
						}
					}
				}
			}
		},
		getFlatValues: function (rec, parent, level) {
			if (!level) level = 0;
			if (!parent) parent = this.values;
			var objs = [];
			var next_level = level + 1;
			for (var item in rec) {
				if (typeof rec[item] != 'string') {
					var obj = null;
					for (var sub in rec[item]) {
						if (sub == parseInt(sub)) {
							var temp = {};
							var newParent = rec[item];
							temp[0] = rec[item][sub];
							temp = this.getFlatValues(temp, newParent, next_level);
							for (var index = 0; index < temp.length; index++) {
								objs.push(temp[index]);
							}
						} else if (sub == 'relation') {
							var rel = {};
							rel.relation = rec[item][sub];
							rel.level = next_level;
							rel.parent = rec[item];
							objs.push(rel);
						} else {
							obj = Object.assign({}, rec[item]);
							obj.level = level;
							obj.parent = parent;
						}
					}
					if (obj) objs.push(obj);
				} else {
					var topRel = {};
					topRel.relation = rec[item];
					topRel.level = level;
					topRel.parent = rec;
					objs.push(topRel);
				}
			}
			return objs;
		},
		recurringLevelUp: function (objs, obj, parent, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var recurring = false;
			for (var o in objs) {
				if (typeof objs[o] != 'string') {
					if (objs[o] == parent) {
						var index = Object.keys(objs).length - 1;
						objs[index] = obj;
						delete objs[index].level;
						delete objs[index].parent;
						for (var ob in objs[o]) {
							if (typeof objs[ob] != 'string') {
								if (this.checkPrimaryKeys(objs[o][ob], obj)) {
									delete objs[o][ob];
									if (Object.keys(objs[o]).length - 1 < 2) {
										objs[o] = objs[o][Object.keys(objs[o])[0]];
									}
									break;
								}
							}
						}
						break;
					} else {
						for (var sub in objs[o]) {
							if (sub == parseInt(sub)) {
								recurring = true;
								break;
							}
						}
						if (recurring) {
							this.recurringLevelUp(objs[o], obj, parent, next_level);
							recurring = false;
						}
					}
				}
			}
		},
		recurringCheckRelation: function (objs, level) {
			if (!level) level = 0;
			var next_level = level + 1;
			var recurring = false;
			var done = false;
			var count;
			for (var o in objs) {
				if (objs.hasOwnProperty(o)) {
					if (!done) {
						count = Object.keys(objs).length;
						if (count < 3 && objs.hasOwnProperty('relation')) {
							delete objs.relation;
						} else if (count > 1 && !objs.hasOwnProperty('relation')) {
							objs.relation = 'AND';
						}
						done = true;
					}
					if (typeof objs[o] != 'string') {
						for (var sub in objs[o]) {
							if (sub == parseInt(sub)) {
								recurring = true;
								break;
							}
						}
						if (recurring) {
							this.recurringCheckRelation(objs[o], next_level);
							recurring = false;
						}
					}
				}
			}
			return count;
		},
		normalizeValues: function (objs) {
			var temp = {};
			var count = 0;
			var recurring = false;
			for (var o in objs) {
				if (o == parseInt(o)) {
					temp[count] = objs[o];
					for (var sub in objs[o]) {
						if (sub == parseInt(sub)) {
							recurring = true;
							break;
						}
					}
					if (recurring) {
						temp[count] = this.normalizeValues(objs[o]);
						recurring = false;
					}
					count++;
				} else {
					temp[o] = objs[o];
				}
			}
			return temp;
		},
		currentFlatMethod: function (array) {
			if (Object.keys(array).length === 0) return '';
			return JSON.stringify(array);
		},
		afterChange: function (update) {
			if (update) {
				this.recurringCheckRelation(this.values);
				this.values = Object.assign({}, this.normalizeValues(this.values));
			}
			this.flat = this.currentFlatMethod(this.values);
			this.list = this.getFlatValues(this.values);
			this.$emit('changed', this.flat, this.eventQuery);
		},
		addValue: function () {
			var self = this;
			if (this.validate()) {
				var newObj = {};
				for (var df in this.defData) {
					if (this.defData.hasOwnProperty(df)) {
						for (var index = 0; index < this.primaryKeys.length; index++) {
							var item = this.primaryKeys[index];
							if (df == item && self.treeInputs[item]) {
								if (self.defData[df].type != 'date') {
									newObj[df] = self.convertTerms(self.treeInputs[item]);
								} else {
									newObj[df] = self.convertDate(self.treeInputs[item]);
								}
							}
						}
						if (this.defData[df].type == 'param') newObj[df] = this.defData[df].values[0];
					}
				}
				if (!this.editMode) {
					var count = 0;
					for (var value in this.values) {
						if (this.values.hasOwnProperty(value)) {
							count++;
							if (typeof this.values[value] == 'string') {
								count--;
							}
						}
					}
					this.values[count] = newObj;
					if (count > 0) {
						var obj = this.values;
						this.values = Object.assign({}, this.values, obj);
					}
				} else {
					this.recurringRowEdit(this.values, this.currentRow, newObj);
					this.editMode = false;
					this.currentRow = null;
				}
				this.treeInputs = {};
				this.afterChange(true);
			}
		},
		editRow: function (row) {
			var self = this;
			this.errorShow = false;
			this.editMode = true;
			this.currentRow = row;
			for (var df in this.defData) {
				if (this.defData.hasOwnProperty(df)) {
					for (var index = 0; index < this.primaryKeys.length; index++) {
						var item = this.primaryKeys[index];
						if (df == item) {
							if (self.defData[df].type != 'date') {
								self.treeInputs[item] = self.flatTerms(row[item]);
							} else {
								self.treeInputs[item] = self.flatDate(row[item]);
							}
						}
					}
				}
			}
		},
		groupRows: function () {
			if (this.checkedRows.length > 1) {
				var sameLevels = true;
				var sameParents = true;
				var currentLevel = this.checkedRows[0].level;
				var currentParent = this.checkedRows[0].parent;
				var newObj = {};
				var count = 0;
				for (var index = 0; index < this.checkedRows.length; index++) {
					var row = this.checkedRows[index];
					if (row.level != currentLevel) {
						sameLevels = false;
						sameParents = false;
					} else if (row.parent != currentParent) sameParents = false;
					newObj[count] = Object.assign({}, row);
					delete newObj[count].level;
					delete newObj[count].parent;
					count++;
				}
				if (sameParents && sameLevels) {
					this.recurringSwitch(this.values, newObj, currentParent);
				}
				this.checkedRows = [];
				this.afterChange(true);
			}
		},
		ungroupRow: function (row) {
			this.recurringLevelUp(this.values, row, row.parent);
			this.afterChange(true);
		},
		deleteRow: function (row) {
			this.recurringRowDelete(this.values, row);
			this.afterChange(true);
		},
		changeRelation: function (row) {
			this.recurringChangeRelation(this.values, row);
			this.afterChange(false);
		},
		changeParameter: function (row, param, values) {
			this.recurringChangeParameter(this.values, row, param, values);
			this.afterChange(false);
		},
		convertTerms: function (values) {
			var arr = values.split(',');
			if (arr.length != 1) {
				var temp_arr = [];
				for (var index = 0; index < arr.length; index++) {
					var item = arr[index];
					item = item.trim();
					if (item && item.length > 0) temp_arr.push(item);
				}
				return temp_arr;
			} else {
				return arr[0];
			}
		},
		convertDate: function (values) {
			if (!/^({%[a-zA-Z0-9_| ]*%})$/.test(values)) {
				var arr = values.split('|');
				if (arr[0] == parseInt(arr[0])) {
					var temp_arr = {};
					if (!arr[1]) arr[1] = '1';
					if (!arr[2]) arr[2] = '1';
					temp_arr.year = arr[0].trim();
					temp_arr.month = arr[1].trim();
					temp_arr.day = arr[2].trim();
					return temp_arr;
				} else {
					return arr[0].trim();
				}
			} else {
				return values;
			}
		},
		convertInts: function (values) {
			if (values == parseInt(values)) return parseInt(values);
			return null;
		},
		flatTerms: function (values) {
			if (typeof values == 'object') values = values.join();
			return values;
		},
		flatDate: function (values) {
			if (typeof values == 'object') {
				var arr = [];
				for (var prop in values) {
					if (values.hasOwnProperty(prop)) {
						arr.push(values[prop]);
					}
				}
				values = arr.join('|');
			}
			return values;
		},
		error: function (type) {
			this.errorShow = false;
			switch (type) {
				case 'badInput':
					this.errorMsg = sm.errorBadInput;
					break;
				case 'duplicates':
					this.errorMsg = sm.errorDuplicatesValues;
					break;
				default:
					this.errorMsg = sm.errorDefault;
					break;
			}
			this.errorShow = true;
		},
		validate: function () {
			var self = this;
			var valid = true;
			var notEmpty = false;
			var error = this.error;
			var regString = /^[A-Za-z0-9-_{}%,|. ]+$/;
			for (var df in this.defData) {
				if (this.defData.hasOwnProperty(df)) {
					for (var index = 0; index < this.primaryKeys.length; index++) {
						var item = this.primaryKeys[index];
						if (typeof self.treeInputs[item] != 'undefined') {
							if (self.treeInputs[item] !== '') notEmpty = true;
							if (df == item) {
								switch (self.defData[df].type) {
									case 'int':
										if (!self.defData[df].reg.test(self.treeInputs[item]) && self.treeInputs[item] !== '') {
											error('badInput');
											valid = false;
										}
										break;
									case 'intarray':
										if (self.treeInputs[item] !== '') {
											var arr = self.treeInputs[item].split(',');
											for (var i = 0; i < arr.length; i++) {
												if (!self.defData[df].reg.test(arr[i].trim())) {
													error('badInput');
													valid = false;
												}
											}
										}
										break;
									case 'string':
									/*
         case 'array':
         	if (!regString.test(self.treeInputs[item]) && self.treeInputs[item] !== '') {
         		error('badInput');
         		valid = false;
         	}
         	break;
         */
									case 'date':
										if (self.treeInputs[item] !== '') {
											if (!/^({%[a-zA-Z0-9_| ]*%})$/.test(self.treeInputs[item])) {
												var date = self.treeInputs[item].split('|');
												if (/^(19|20)\d{2}$/.test(date[0].trim())) {
													if (!date[1]) date[1] = '1';
													if (!date[2]) date[2] = '1';
													if (!/^(1[0-2]|[1-9])$/.test(date[1].trim())) {
														error('badInput');
														valid = false;
													}
													if (!/^([1-9]|[1-2][0-9]|3[0-1])$/.test(date[2].trim())) {
														error('badInput');
														valid = false;
													}
												} else {
													if (!regString.test(date[0].trim())) {
														error('badInput');
														valid = false;
													}
												}
											}
										}
										break;
								}
								if (self.defData[df].req && self.defData[df].req === true && self.treeInputs[item] === '') {
									error('badInput');
									valid = false;
								}
							}
						} else {
							if (df == item) {
								if (self.defData[df].req && self.defData[df].req === true) {
									error('badInput');
									valid = false;
								}
							}
						}
					}
				}
			}
			if (!notEmpty) {
				error('badInput');
				valid = false;
			}
			return valid;
		}
	}
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Bus_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dictionary_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dictionary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Dictionary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TagButton_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TagButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_TagButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AceEditor_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AceEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AceEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MethodButton_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MethodButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_MethodButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_QueryBuilder_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_QueryBuilder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_QueryBuilder_vue__);








Vue.component('sm-query-builder', __WEBPACK_IMPORTED_MODULE_5__components_QueryBuilder_vue___default.a);
Vue.component('sm-dic', __WEBPACK_IMPORTED_MODULE_1__components_Dictionary_vue___default.a);
Vue.component('sm-editor', __WEBPACK_IMPORTED_MODULE_3__components_AceEditor_vue___default.a);
Vue.component('sm-method-button', __WEBPACK_IMPORTED_MODULE_4__components_MethodButton_vue___default.a);
Vue.component('sm-tag-button', __WEBPACK_IMPORTED_MODULE_2__components_TagButton_vue___default.a);

var collapseMixin = {
	data: {
		collapse: 'sm-collapsed'
	},
	methods: {
		onCollapse: function () {
			this.collapse == '' ? this.collapse = 'sm-collapsed' : this.collapse = '';
		}
	},
	computed: {
		sign: function () {
			var sign;
			if (this.collapse == '') {
				sign = '&minus;';
			} else {
				sign = '&plus;';
			}
			return sign;
		}
	}
};
var dicMixin = {
	data: {
		rows: []
	},
	methods: {
		onRows: function (rows) {
			this.rows = rows;
		}
	}
};
var editorMixin = {
	data: {
		editor: null
	},
	methods: {
		addMethod: function (method) {
			this.editor.insert(method);
			this.editor.focus();
		},
		onInit: function (editor) {
			if (this.editor === null) this.editor = editor;
		}
	}
};
var sm_title = new Vue({
	el: '#sm-title-block',
	mixins: [collapseMixin],
	data: {
		collapse: '',
		shortcode_codes: ''
	}
});
var sm_params = new Vue({
	el: '#sm-parameters-block',
	mixins: [dicMixin, collapseMixin],
	data: {
		collapse: '',
		rows: []
	},
	methods: {
		onRows: function (rows) {
			this.rows = rows.sort(function (a, b) {
				if (a.hasOwnProperty('checkbox') && a.checkbox) {
					return -1;
				} else if (b.hasOwnProperty('checkbox') && b.checkbox) {
					return 1;
				} else {
					return 0;
				}
			});
			this.onChange(rows);
		},
		onChange: function (data) {
			var string = '';
			data.sort(function (a, b) {
				if (a.hasOwnProperty('checkbox') && a.checkbox) {
					return -1;
				} else if (b.hasOwnProperty('checkbox') && b.checkbox) {
					return 1;
				} else {
					return 0;
				}
			});
			data.filter(function (row) {
				string += ' ' + row.name + '="' + row.value + '"';
			});

			sm_title.shortcode_codes = string.replace(/(\])/g, '}').replace(/(\[)/g, '{');
		}
	}
});
var sm_query = new Vue({
	el: '#sm-query-block',
	mixins: [dicMixin, collapseMixin],
	data: {
		collapse: '',
		isNotHidden: false,
		currentGroup: '',
		qb: [],
		paramsRows: sm_params.rows
	},
	methods: {
		listGroups: function (group) {
			this.currentGroup.className = 'sm-hidden args-group';
			var group = document.getElementById(group + '-group');
			group.className = '';
			this.currentGroup = group;
		},
		editAtts: function (row) {
			__WEBPACK_IMPORTED_MODULE_0__components_Bus_js__["a" /* default */].$emit('editCurrentArg', 'query-builder', row);
		},
		deleteAtts: function (row) {
			__WEBPACK_IMPORTED_MODULE_0__components_Bus_js__["a" /* default */].$emit('deleteCurrentArg', 'query-builder', row);
		},
		onCheckMethod: function (method) {
			__WEBPACK_IMPORTED_MODULE_0__components_Bus_js__["a" /* default */].$emit('checkMethod', 'query-dic', method);
		},
		onQueryChange: function (values, method) {
			var rows = [{
				name: method,
				value: values
			}];
			__WEBPACK_IMPORTED_MODULE_0__components_Bus_js__["a" /* default */].$emit('fullDic', 'query-dic', rows);
		},
		addTemplateArgs: function (rows) {
			__WEBPACK_IMPORTED_MODULE_0__components_Bus_js__["a" /* default */].$emit('fullDic', 'query-dic', rows);
		}
	}
});
var sm_query_main = new Vue({
	el: '#sm-query-main-block',
	mixins: [collapseMixin, editorMixin],
	data: {
		collapse: '',
		main: '',
		rows: sm_params.rows
	}
});
var sm_main = new Vue({
	el: '#sm-main-block',
	mixins: [collapseMixin, editorMixin],
	data: {
		collapse: '',
		main_content: '',
		rows: sm_params.rows
	}
});
var sm_scripts = new Vue({
	el: '#sm-scripts-block',
	mixins: [collapseMixin, dicMixin, editorMixin],
	data: {
		collapse: '',
		scripts: '',
		paramsRows: sm_params.rows
	}
});
var sm_styles = new Vue({
	el: '#sm-styles-block',
	mixins: [collapseMixin, dicMixin, editorMixin],
	data: {
		collapse: '',
		styles: '',
		paramsRows: sm_params.rows
	}
});
var sm_integration = new Vue({
	el: '#sm-integration-block',
	mixins: [collapseMixin],
	data: {
		collapse: ''
	}
});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(17),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(19),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "sm-button sm-edit-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.listGroups
    }
  }, [_c('div', {
    staticClass: "dashicons-before",
    class: _vm.icon
  }), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sm-mt"
  }, [(_vm.secondActive || _vm.firstActive) ? _c('p', [_vm._v(_vm._s(_vm.strings.queryMainDesc))]) : _vm._e(), _vm._v(" "), (_vm.firstActive) ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.strings.queryGroup))]), _vm._v(" "), _vm._l((_vm.qb), function(tag, index) {
    return _c('sm-group-button', {
      key: tag.id,
      attrs: {
        "icon": tag[1],
        "group": index
      },
      on: {
        "groups": function($event) {
          _vm.stepMethods(index, tag.id)
        }
      }
    }, [_vm._v(_vm._s(tag.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.secondActive) ? _c('div', [_c('strong', [_vm._v(_vm._s(_vm.strings.queryMethod))]), _vm._v(" "), _vm._l((_vm.qb[_vm.currentGroup].methods), function(tag, index) {
    return _c('sm-group-button', {
      key: tag.name,
      attrs: {
        "icon": tag[1],
        "group": index
      },
      on: {
        "groups": function($event) {
          _vm.stepArgs(tag.name, tag.method, tag.type)
        }
      }
    }, [_vm._v(_vm._s(tag.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.thirdActive) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.strings.queryArgs) + " "), _c('strong', [_vm._v(_vm._s(_vm.currentName) + " ( " + _vm._s(_vm.currentMethod) + " )")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.strings.queryDesc) + "\n\t\t\t"), _vm._l((_vm.params), function(param, index) {
    return _c('span', {
      key: param.name,
      staticClass: "sm-inline-attr sm-inline-attr-query"
    }, [_c('strong', [_vm._v("{[ " + _vm._s(param.name) + " ]}")])])
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "description sm-pb30"
  }, [_vm._v(_vm._s(_vm.strings.queryDescCP))]), _vm._v(" "), _c('div', [(_vm.defaultInput) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueInput),
      expression: "valueInput"
    }],
    ref: "inputValueArg",
    attrs: {
      "type": "text",
      "placeholder": _vm.valuePlaceholder
    },
    domProps: {
      "value": (_vm.valueInput)
    },
    on: {
      "keydown": function($event) {
        _vm.errorShow = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueInput = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.currentDesc)
    }
  })]), _vm._v(" "), (_vm.currentType == 'taxonomy' || _vm.currentType == 'meta' || _vm.currentType == 'date') ? _c('sm-tree-input', {
    attrs: {
      "component-id": "query-tree",
      "button-title": _vm.treeData.buttonTitle,
      "def": _vm.defQuery,
      "def-data": _vm.treeData.defs,
      "event-query": _vm.treeData.queryName
    },
    on: {
      "changed": _vm.emitChanges
    }
  }) : _vm._e(), _vm._v(" "), (_vm.defaultInput) ? _c('button', {
    staticClass: "sm-button sm-edit-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addValue
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), (_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.editTitle))]) : _c('span', [_vm._v(_vm._s(_vm.addTitle))]), _vm._v(" " + _vm._s(_vm.buttonTitle))]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errorShow) ? _c('span', {
    staticClass: "sm-error"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sm-mt10"
  }, [(_vm.secondActive | _vm.thirdActive) ? _c('button', {
    staticClass: "sm-button sm-loop-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backStep
    }
  }, [_c('i', {
    staticClass: "icon-level-up"
  }), _vm._v(_vm._s(_vm.backTitle) + "\n\t\t")]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "sm-list"
  }, _vm._l((_vm.values), function(row, index) {
    return _c('li', {
      key: row.id,
      staticClass: "sm-mr10"
    }, [_c('a', {
      staticClass: "sm-edit sm-edit-flat",
      staticStyle: {
        "top": "1px",
        "margin-left": "4px"
      },
      attrs: {
        "href": "#",
        "title": _vm.editTitle
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editRow(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-pencil"
    })]), _vm._v(" "), _c('a', {
      staticClass: "sm-delete sm-delete-flat",
      attrs: {
        "href": "#",
        "title": _vm.deleteTitle
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteRow(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-cancel sm-lg",
      staticStyle: {
        "top": "2px",
        "left": "-4px"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "value",
      staticStyle: {
        "left": "-3px",
        "position": "relative"
      }
    }, [_vm._v(_vm._s(row))])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sm-flex sm-flex-justify-start"
  }, _vm._l((_vm.inputs), function(obj, key) {
    return _c('div', {
      key: _vm.inputs[key],
      staticClass: "sm-mb10 sm-input-block"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.treeInputs[key]),
        expression: "treeInputs[key]"
      }],
      staticClass: "sm-input-query",
      attrs: {
        "type": "text",
        "placeholder": obj
      },
      domProps: {
        "value": (_vm.treeInputs[key])
      },
      on: {
        "keydown": function($event) {
          _vm.errorShow = false
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.treeInputs,
            $$idx = key;
          if (!Array.isArray($$exp)) {
            _vm.treeInputs[key] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "description",
      domProps: {
        "innerHTML": _vm._s(_vm.defData[key].desc)
      }
    })])
  })), _vm._v(" "), _c('button', {
    staticClass: "sm-button sm-edit-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addValue
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), (_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.editTitle))]) : _c('span', [_vm._v(_vm._s(_vm.addTitle))]), _vm._v(" " + _vm._s(_vm.buttonTitle) + "\n\t")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errorShow) ? _c('span', {
    staticClass: "sm-error"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "sm-mt10 sm-bt sm-pt10"
  }, [_vm._v("With selected: \n\t\t"), _c('button', {
    staticClass: "sm-button sm-edit-button sm-ml10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.groupRows
    }
  }, [_c('span', {
    staticClass: "icon-list-add"
  }), _vm._v(_vm._s(_vm.groupTitle))])]), _vm._v(" "), _c('ul', {
    staticClass: "sm-list"
  }, _vm._l((_vm.list), function(row, index) {
    return _c('li', {
      key: _vm.list[index],
      staticClass: "sm-li",
      style: (_vm.liPadding(row.level))
    }, [(!row.relation) ? _c('div', {
      staticClass: "sm-flex sm-flex-align-center"
    }, [_c('div', {
      staticClass: "sm-control"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedRows),
        expression: "checkedRows"
      }],
      staticClass: "sm-checkbox",
      attrs: {
        "id": _vm.checkboxId(index),
        "type": "checkbox"
      },
      domProps: {
        "value": row,
        "checked": Array.isArray(_vm.checkedRows) ? _vm._i(_vm.checkedRows, row) > -1 : (_vm.checkedRows)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.checkedRows,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.checkedRows = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.checkedRows = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedRows = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": _vm.checkboxId(index)
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editRow(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon-pencil sm-edit sm-tax-buttons"
    })]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteRow(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon-cancel sm-del sm-tax-buttons"
    })]), _vm._v(" "), (row.level > 0) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.ungroupRow(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon-reply sm-level-up sm-tax-buttons"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "sm-bl-row sm-row",
      attrs: {
        "index": row.level
      }
    }, _vm._l((_vm.defData), function(obj, key) {
      return (typeof row[key] != 'undefined') ? _c('p', {
        key: _vm.defData[key],
        staticClass: "sm-m0"
      }, [(_vm.checkClass(key)) ? _c('strong', {
        class: _vm.checkPadding(obj.type)
      }, [_vm._v(_vm._s(obj.title) + ":")]) : _c('span', [_vm._v(_vm._s(obj.title) + ":")]), _vm._v(" "), ((obj.type != 'array' && obj.type != 'date' && obj.type != 'intarray')) ? _c('span', {
        staticClass: "value sm-ml10",
        class: _vm.checkClass(key)
      }, [_vm._v(_vm._s(row[key]))]) : _vm._e(), _vm._v(" "), _vm._l((row[key]), function(item, index) {
        return ((obj.type == 'array' || obj.type == 'date' || obj.type == 'intarray') && typeof row[key] == 'object') ? _c('span', {
          key: row[key][index],
          staticClass: "sm-array-key sm-mr10"
        }, [_vm._v(_vm._s(item))]) : _vm._e()
      }), _vm._v(" "), ((obj.type == 'array' || obj.type == 'date' || obj.type == 'intarray') && typeof row[key] == 'string') ? _c('span', {
        staticClass: "sm-array-key sm-mr10"
      }, [_vm._v(_vm._s(row[key]))]) : _vm._e(), _vm._v(" "), (obj.type == 'param') ? _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.changeParameter(row, key, obj.values)
          }
        }
      }, [_c('span', {
        staticClass: "icon-switch sm-switch sm-tax-buttons"
      })]) : _vm._e()], 2) : _vm._e()
    }))]) : _vm._e(), _vm._v(" "), (row.relation) ? _c('div', {
      staticClass: "sm-pl10 sm-bl-rel sm-rel",
      style: (_vm.relationMargin(row.level)),
      attrs: {
        "index": row.level
      }
    }, [_c('p', {
      staticClass: "sm-m0"
    }, [_c('span', [_vm._v(_vm._s(_vm.relationTitle) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "value sm-ml10"
    }, [_vm._v(_vm._s(row.relation))]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeRelation(row)
        }
      }
    }, [_c('span', {
      staticClass: "icon-switch sm-switch sm-tax-buttons"
    })])])]) : _vm._e()])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "sm-button sm-edit-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addTag
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('ul', {
    staticClass: "sm-list"
  }, _vm._l((_vm.rows), function(row, index) {
    return _c('li', {
      key: row[index],
      staticClass: "sm-li",
      class: _vm.currentIndex == index ? 'current' : ''
    }, [(!_vm.showFull(index)) ? _c('a', {
      staticClass: "sm-edit sm-edit-flat sm-eye",
      attrs: {
        "href": "#",
        "title": _vm.collapseTitle
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.collapseRow(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-eye"
    })]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "sm-edit sm-edit-flat",
      attrs: {
        "href": "#",
        "title": _vm.editTitle
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editRow(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon-pencil"
    })]), _vm._v(" "), _c('a', {
      staticClass: "sm-delete sm-delete-flat",
      attrs: {
        "href": "#",
        "title": _vm.deleteTitle
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteRow(index, false)
        }
      }
    }, [_c('span', {
      staticClass: "icon-cancel sm-lg"
    })]), _vm._v(" "), _c('div', {
      staticClass: "sm-flex sm-flex-justify-start"
    }, [(row.title) ? _c('div', {
      staticClass: "sm-flex-full-no-padding sm-italic",
      staticStyle: {
        "padding-bottom": "3px",
        "color": "#3498db",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(row.title))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "name",
      class: {
        required: row.checkbox
      }
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('span', {
      staticClass: "sm-sep"
    }, [_vm._v(":")]), _vm._v(" "), (_vm.showFull(index)) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.calculateValue(row.value, index))
      }
    }) : _c('div', [_c('div', {
      staticClass: "sm-arg-block"
    }, [_c('span', {
      staticClass: "value params"
    }, [_vm._v("{...}")])])]), _vm._v(" "), (_vm.hasRadios) ? _c('div', {
      staticClass: "sm-arg-param-desc"
    }, [_vm._v(_vm._s(row.radio ? _vm.radios[row.radio] : _vm.radios[0]))]) : _vm._e(), _vm._v(" "), (row.desc) ? _c('div', {
      staticClass: "sm-flex-full-no-padding sm-italic",
      staticStyle: {
        "padding-top": "3px"
      }
    }, [_vm._v(_vm._s(row.desc))]) : _vm._e()])])
  })), _vm._v(" "), (_vm.hasControls) ? _c('p', [_vm._v("Edit current parameter:")]) : _vm._e(), _vm._v(" "), (_vm.hasExtendedControls) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titleInput),
      expression: "titleInput"
    }],
    ref: "inputTitle",
    staticClass: "sm-large sm-mb10",
    staticStyle: {
      "max-width": "506px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.titlePlaceholder
    },
    domProps: {
      "value": (_vm.titleInput)
    },
    on: {
      "keydown": function($event) {
        _vm.errorShow = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titleInput = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasExtendedControls) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descInput),
      expression: "descInput"
    }],
    ref: "inputDesc",
    staticClass: "sm-tinymce-field-input",
    staticStyle: {
      "max-width": "506px"
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.descPlaceholder
    },
    domProps: {
      "value": (_vm.descInput)
    },
    on: {
      "keydown": function($event) {
        _vm.errorShow = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descInput = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasControls) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameInput),
      expression: "nameInput"
    }],
    ref: "inputName",
    attrs: {
      "type": "text",
      "placeholder": _vm.namePlaceholder
    },
    domProps: {
      "value": (_vm.nameInput)
    },
    on: {
      "keydown": function($event) {
        _vm.errorShow = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameInput = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasControls) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueInput),
      expression: "valueInput"
    }],
    ref: "inputValue",
    attrs: {
      "type": "text",
      "placeholder": _vm.valuePlaceholder
    },
    domProps: {
      "value": (_vm.valueInput)
    },
    on: {
      "keydown": function($event) {
        _vm.errorShow = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueInput = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasRadios) ? _c('div', {
    staticClass: "sm-radio-wrapper"
  }, [(_vm.radioDesc) ? _c('div', {
    staticClass: "sm-mr10 sm-mb10"
  }, [_vm._v(_vm._s(_vm.radioDesc))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.radios), function(radio, id_radio) {
    return _c('div', {
      key: _vm.radios[id_radio],
      staticStyle: {
        "margin-bottom": "3px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.radioInput),
        expression: "radioInput"
      }],
      staticClass: "sm-radio",
      attrs: {
        "type": "radio",
        "id": 'sm_radio_' + _vm.componentId + '_' + id_radio
      },
      domProps: {
        "value": id_radio,
        "checked": _vm._q(_vm.radioInput, id_radio)
      },
      on: {
        "__c": function($event) {
          _vm.radioInput = id_radio
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'sm_radio_' + _vm.componentId + '_' + id_radio
      }
    }, [_c('span', [_vm._v(_vm._s(radio))]), (_vm.tooltips[id_radio]) ? _c('a', {
      staticClass: "sm-info",
      attrs: {
        "href": "javascript:void(0);",
        "data-placement": "right",
        "rel": "tooltip",
        "title": _vm.tooltips[id_radio]
      }
    }, [_c('span', {
      staticClass: "icon-info"
    })]) : _vm._e()])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.hasCheckbox) ? _c('p', {
    staticClass: "sm-required-wrapper"
  }, [(_vm.checkboxDesc) ? _c('span', {
    staticClass: "sm-mr10"
  }, [_vm._v(_vm._s(_vm.checkboxDesc))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkboxInput),
      expression: "checkboxInput"
    }],
    staticClass: "sm-checkbox",
    attrs: {
      "type": "checkbox",
      "id": "sm_checkbox_0"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkboxInput) ? _vm._i(_vm.checkboxInput, null) > -1 : (_vm.checkboxInput)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkboxInput,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checkboxInput = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkboxInput = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkboxInput = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "sm_checkbox_0"
    }
  }), (_vm.checkboxTooltip) ? _c('a', {
    staticClass: "sm-info",
    attrs: {
      "data-placement": "bottom",
      "href": "javascript:void(0);",
      "rel": "tooltip",
      "title": _vm.checkboxTooltip
    }
  }, [_c('span', {
    staticClass: "icon-info"
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.hasControls) ? _c('button', {
    staticClass: "sm-button sm-edit-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "icon-plus"
  }), (_vm.editMode) ? _c('span', [_vm._v(_vm._s(_vm.editTitle))]) : _c('span', [_vm._v(_vm._s(_vm.addTitle))]), _vm._v(" " + _vm._s(_vm.buttonTitle) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errorShow) ? _c('span', {
    staticClass: "sm-error"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e()]), _vm._v(" "), (_vm.hasInputs) ? _c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.rowsId()
    },
    domProps: {
      "value": _vm.inputValues()
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sm-editor"
    }
  })
},staticRenderFns: []}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// shortcode-mastery.min.js